import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import PublicLayout from "@/components/PublicLayout";
import PanelLayout from "@/components/PanelLayout";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ServicesPage from "@/pages/Services";
import ContactPage from "@/pages/Contact";
import CustomerPortalPage from "@/pages/CustomerPortal";
import PanelLoginPage from "@/pages/PanelLogin";
import DashboardPage from "@/pages/panel/Dashboard";
import ProductsPage from "@/pages/panel/Products";
import StaffPage from "@/pages/panel/Staff";
import RequestsPage from "@/pages/panel/Requests";
import PoliciesPage from "@/pages/panel/Policies";
import SettingsPage from "@/pages/panel/Settings";
import "@/App.css";

function RequireAuth({ children, admin }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/panel" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/panel/dashboard" replace />;
  return children;
}

function PanelEntry() {
  const { user } = useAuth();
  if (user) return <Navigate to="/panel/dashboard" replace />;
  return <PanelLoginPage />;
}

export default function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="light" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/hakkimizda" element={<AboutPage />} />
              <Route path="/hizmetler" element={<ServicesPage />} />
              <Route path="/iletisim" element={<ContactPage />} />
            </Route>

            <Route path="/musteri" element={<CustomerPortalPage />} />

            <Route path="/panel" element={<PanelEntry />} />
            <Route
              path="/panel/*"
              element={
                <RequireAuth>
                  <PanelLayout />
                </RequireAuth>
              }
            >
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="requests" element={<RequestsPage />} />
              <Route path="policies" element={<PoliciesPage />} />
              <Route path="products" element={<RequireAuth admin><ProductsPage /></RequireAuth>} />
              <Route path="staff" element={<RequireAuth admin><StaffPage /></RequireAuth>} />
              <Route path="settings" element={<RequireAuth admin><SettingsPage /></RequireAuth>} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}
